import { dataFetcherGet } from 'lib/data-fetcher';
import {
  SearchType,
  GetPolicyDocumentsCallback,
  GetPolicyDocumentsFunction,
  GroupsResponse,
  PoliciesResponse,
} from '../../../models/policy-doc-search-types';
import { filterDocumentsByTitle, getGroupsFromDocuments } from '../Functions';

export const getPolicyDocumentsFromDAM: GetPolicyDocumentsFunction = (
  searchType: SearchType,
  searchTerm: string,
  callBack: GetPolicyDocumentsCallback
) => {
  'use server';

  let queryString = '';
  const apiRootUrl = '';
  const apiCall = `/api/policy-docs-search/searchPolicyDocuments`;

  const searchByAPI = searchTerm && searchType == SearchType.SearchDocumentText;
  const searchByTitle = searchTerm && searchType == SearchType.SearchTitleOnly;

  if (searchByAPI) {
    queryString = `?search=${searchTerm}`;
  }

  const apiUrl = `${apiRootUrl}${apiCall}${queryString}`;

  if (searchByAPI) {
    dataFetcherGet<PoliciesResponse>(apiUrl).then((result) => {
      const { policies } = result.data;
      const groups = getGroupsFromDocuments(policies);
      callBack(groups);
    });
  } else {
    dataFetcherGet<GroupsResponse>(apiUrl).then((result) => {
      let { groups } = result.data;
      groups = searchByTitle ? filterDocumentsByTitle(groups, searchTerm) : groups;
      callBack(groups);
    });
  }
};
